import styled from 'styled-components'

export const GraphAnalysisContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
  align-items: center;
  align-self: center;
`
